module.exports = __webpack_public_path__ + "img/202501_firstserum.4289674b.jpg";